<template>
    <div id="kaipiao">
        <MyTitle theTitle="填写开票信息"/>

        <div class="fd-com-scroll" v-if="isShow">

            <template v-for="(item,index) in list">
                <Slogan :theTitle="item.title"/>

                <van-cell-group>
                    <template v-for="(item1,index1) in item.dataList">

                        <template v-if="!item1.type">
                            <van-field
                                v-model="formData[item1.key]"
                                :disabled="item1.disabled"
                                :required="item1.required?item1.required[propIndex]:true"
                                :label="item1.label"
                                :placeholder="'请输入'+item1.label"
                            ></van-field>
                        </template>

                        <template v-else-if="item1.type==='dropdown'">
                            <van-field
                                readonly
                                clickable
                                right-icon="arrow"
                                :required="item1.required?item1.required[propIndex]:true"
                                name="picker"
                                :label="item1.label"
                                :value="assist[item1.key+'_Text']"
                                :placeholder="'点击选择'+item1.label"
                                @click="onAlert(item1)"
                            />
                            <van-popup v-model="assist['showPicker_'+item1.key]" position="bottom">
                                <van-picker
                                    show-toolbar
                                    :columns="ddListAll[item1.source]"
                                    :default-index="item1.initIndex"
                                    @confirm="(item2,index2)=>onConfirm(item2,index2,item1.key)"
                                    @cancel="assist['showPicker_'+item1.key] = false"
                                />
                            </van-popup>
                        </template>

                        <template v-else-if="item1.type==='textarea'">
                            <van-field
                                class="fd-textarea"
                                type="textarea"
                                rows="2"
                                show-word-limit
                                autosize
                                :required="item1.required?item1.required[propIndex]:true"
                                v-model="formData[item1.key]"
                                :label="item1.label"
                                :maxlength="item1.maxlength"
                                :placeholder="'请输入'+item1.label"
                            />
                        </template>


                    </template>
                </van-cell-group>

            </template>






<!--            <Slogan theTitle="发票类型"/>
            <van-cell-group>
                <van-field
                    readonly
                    clickable
                    right-icon="arrow"
                    required
                    name="picker"
                    label="发票类型"
                    :value="formData.nFplx_Text"
                    placeholder="点击选择发票类型"
                    @click="formData.showPicker_nFplx = true"
                />
                <van-popup v-model="formData.showPicker_nFplx" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns_nFplx"
                        :default-index="0"
                        @confirm="(item,index)=>onConfirm(item,index,'nFplx')"
                        @cancel="formData.showPicker_nFplx = false"
                    />
                </van-popup>
            </van-cell-group>-->

<!--            <Slogan theTitle="基本信息"/>
            <van-cell-group>
                <van-field
                    v-model="formData.cDbh"
                    :disabled="false"
                    required
                    label="保单号"
                    placeholder="请输入保单号"
                ></van-field>

                <van-field
                    readonly
                    clickable
                    right-icon="arrow"
                    required
                    name="picker"
                    label="抬头类型"
                    :value="formData.nTtlx_Text"
                    placeholder="点击选择抬头类型"
                    @click="formData.showPicker_nTtlx = true"
                />
                <van-popup v-model="formData.showPicker_nTtlx" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="columns_nTtlx"
                        :default-index="0"
                        @confirm="(item,index)=>onConfirm(item,index,'nTtlx')"
                        @cancel="formData.showPicker_nTtlx = false"
                    />
                </van-popup>

                <van-field
                    class="fd-textarea"
                    v-model="formData.cDz"
                    rows="2"
                    autosize
                    label="地址"
                    type="textarea"
                    maxlength="50"
                    placeholder="请输入地址"
                    show-word-limit
                />
            </van-cell-group>-->


<!--            <Slogan theTitle="寄送信息"/>
            <van-cell-group>
                <van-field
                    v-model="formData.cLxr"
                    :required="false"
                    label="联系人"
                    placeholder="请输入联系人"
                ></van-field>
            </van-cell-group>-->
        </div>

            <div class="fd-com-btn-container">
                <van-button
                    type="info"
                    round
                    plain
                    :disabled="false"
                    @click="goBack()"
                >
                    取消
                </van-button>
                <van-button
                    type="info"
                    round
                    :disabled="false"
                    @click="submitForm()"
                >
                    提交
                </van-button>
            </div>

    </div>

</template>

<script>

import MyTitle from '../../../components/common/myTitle';
import Slogan from '../../../components/common/slogan';
import {
    Rule_nFplx,
    Rule_cDbh,
    Rule_nTtlx,
    Rule_cTtmc,
    Rule_nZzlx,
    Rule_cNsrmc,
    Rule_cNsrsbh,
    Rule_cDh,
    Rule_cKhyhmc,
    Rule_cKhyhzh,
    Rule_cDz,
    Rule_cLxr,
    Rule_cLxrdh,
    Rule_cYx,
    Rule_nFsdz,
    Rule_cZzhm
} from '../../../utils/validator/rules2';
import validate from "@/utils/validator/validator";
import {list2,formData2,arrList2} from './dataInit'

import {extend,transformDdl} from '../../../utils/common';
import {getCode,getkpRyxx,createKP} from '../../../api/common';

export default {
    name: "kpEdit",
    data(){
      return {

          list: extend([],list2),
          formData:extend({},formData2),
          arrList: extend({},arrList2),

         /* columns_nFplx:[{
              value: "1",
              text:'增值税专用发票',
          }, {
              value: "2",
              text:'增值税普通发票',
          }],

          columns_nTtlx: [{
              value: "1",
              text:'个人',
          }, {
              value: "2",
              text:'企业',
          }],*/

          radio: '1',
          message:'',

          assist:{
              nFplx_Text:'增值税专用发票',
              showPicker_nFplx:false,

              nTtlx_Text:'企业',
              showPicker_nTtlx:false,

              cTtmc_Text:'',
              showPicker_cTtmc:false,

              nZzlx_Text:'',
              showPicker_nZzlx:false,
          },
         /* formData:{
              nFplx:'0',
              cDbh:'',
              nTtlx:'0',
              cDz:'',
              cLxr:''
          },*/


          // 接口数据 isShow判断
          codeList_902001:[],// 发票类型
          codeList_902003:[],// 抬头类型
          codeList_105000:[],// 证件(照)类型-证件 个人
          codeList_109000:[],// 证件(照)类型-证照 企业
          ryxx:[],// 人员信息

          // 辅助数据
          propIndex:'0',
          relation_nFplx_nTtlx:{'1':'2','2':'1'},//发票类型与prop对应关系
          relation_prop:{'1_1':1,'1_2':0,'2_1':1,'2_2':1},
          nTtlxCode:{'1':'codeList_105000','2':'codeList_109000'},

          // 组装数据
          ddListAll:{},
      };
    },
    components: {MyTitle,Slogan},
    computed:{
        // 是否显示
        isShow(){
            console.log('--isShow 111');
            if(this.codeList_902001.length>0&&
                this.codeList_902003.length>0&&
                this.codeList_105000.length>0&&
                this.codeList_109000.length>0&&
                this.ryxx.length>0
            ){
                // this.loadingInstance.close();
                this.initData();
                return true;
            }else{
                return false;
            }
        }
    },
    watch: {
        'formData.nFplx'(val1,val2) {
            console.log('--nFplx',val1,val2,this.formData.nTtlx);
            this.formData.nTtlx=this.relation_nFplx_nTtlx[val1];
            this.assist.nTtlx_Text=this.ddListAll.codeList_902003.filter(i=>i.value===String(this.formData.nTtlx))[0].text;

            if(this.formData.nTtlx==='2'&&val1==='1'&&val2==='2'){
                console.log('--进来 111');
                this.propIndex=1;
                this.changeState('2');
            }
        },
        'formData.nTtlx'(val1,val2) {
            console.log('--nTtlx',val1,val2);
            this.changeState(val1);
        },
        'formData.cTtmc'(val1,val2) {
            console.log('--cTtmc 111',val1,val2);
            let ryInfo=this.ryxx.filter(item=>item.cTtmc===val1)[0];
            console.log('--formData.cTtmc 111',ryInfo,this.formData);
            if(ryInfo){
                this.formData.nZzlx=String(ryInfo.nZzlx);
                console.log('-111111111',this.ddListAll.codeList_zzlx.filter(i=>i.value===String(ryInfo.nZzlx))[0].text);
                this.assist.nZzlx_Text=this.ddListAll.codeList_zzlx.filter(i=>i.value===String(ryInfo.nZzlx))[0].text;
                this.formData.cZzhm=ryInfo.cZzhm;
            }else{
                this.formData.nZzlx='';
                this.assist.nZzlx_Text='';
            }

            //this.formData.nZzlx = this.ryxx.filter(item=>item.cTtmc===val1)
        }
    },
    methods: {
        goBack() {
            history.go(-1)
        },
        //状态切换
        changeState(val1){
            this.propIndex=this.relation_prop[this.formData.nFplx+'_'+String(val1)];
            // this.$refs.myForm_2[0].clearValidate();
            // this.$refs.myForm_3[0].clearValidate();
            // if(this.propIndex===1){
            //     this.formData.cNsrsbh_no='';
            //     this.formData.cNsrsbh_no='';
            //     this.formData.cDh_no='';
            //     this.formData.cKhyhmc_no='';
            //     this.formData.cKhyhzh_no='';
            //     this.formData.cDz_no='';
            // }else{
            //     this.formData.cNsrsbh='';
            //     this.formData.cNsrsbh='';
            //     this.formData.cDh='';
            //     this.formData.cKhyhmc='';
            //     this.formData.cKhyhzh='';
            //     this.formData.cDz='';
            // }
            this.formData.cTtmc='';
            this.assist.cTtmc_Text='';
            this.formData.nZzlx='';
        },
        //弹出下拉框
        onAlert(item){
            console.log('--onAlert 111',item,this.ddListAll.codeList_ry);
            if(item.key==='cTtmc'&&this.ddListAll.codeList_ry.length===0){
                this.$notify('暂无数据');
            }else{
                this.assist['showPicker_'+item.key] = true
            }
        },

        onConfirm(item,index,type) {
            console.log('--onConfirm 111',item,index,type);
            this.formData[type]=item.value;
            this.assist[type+'_Text'] = item.text;
            this.assist['showPicker_'+type] = false;
            /*this.formData.nTtlx=item.value;
            this.formData.nTtlx_Text = item.text;
            this.formData.showPicker_nTtlx = false;*/
        },

        validateFormData(){
            // 校验规则
            let descriptor;
            descriptor = {
                nFplx: Rule_nFplx,
                cDbh: Rule_cDbh,
                nTtlx: Rule_nTtlx,
                cTtmc: Rule_cTtmc,
                nZzlx: Rule_nZzlx,
                cZzhm: new Rule_cZzhm(Number(this.formData.nZzlx), true),
                cNsrmc: Number(this.propIndex) === 0 ? new Rule_cNsrmc(true) : new Rule_cNsrmc(false),
                cNsrsbh: Number(this.propIndex) === 0 ? new Rule_cNsrsbh(true) : new Rule_cNsrsbh(false),
                cDh: Number(this.propIndex) === 0 ? new Rule_cDh(true) : new Rule_cDh(false),
                cKhyhmc: Number(this.propIndex) === 0 ? new Rule_cKhyhmc(true) : new Rule_cKhyhmc(false),
                cKhyhzh: Number(this.propIndex) === 0 ? new Rule_cKhyhzh(true) : new Rule_cKhyhzh(false),
                cDz: Number(this.propIndex) === 0 ? new Rule_cDz(true) : new Rule_cDz(false),
                cLxr: new Rule_cLxr(true),
                cLxrdh: new Rule_cLxrdh(true),
                cYx: new Rule_cYx(false),
                nFsdz: new Rule_nFsdz(true)
            };

            let validated = validate(descriptor, this.formData);
            return validated;
        },
        //组装提交数据
        params(){
            const {dbid,cBxgs}=this;
            let {
                cLxr,cLxrdh,cYx,nFsdz,
                nFplx,cDbh,nTtlx,cTtmc,nZzlx,cZzhm,
                cNsrmc,cNsrsbh,cDh,cKhyhmc,cKhyhzh,cDz
            }=this.formData;
            return {
                jsxx: {cLxr, cLxrdh, cYx, nFsdz},
                kpxx: {
                    cDbId: dbid, cBxgs,
                    nFplx, cDbh, nTtlx, cTtmc, nZzlx, cZzhm,
                    cNsrmc, cNsrsbh, cDh, cKhyhmc, cKhyhzh, cDz,
                }
            };
        },
        submitForm(){
            console.log('--数据提交',this.formData,this.params());
            const validated = this.validateFormData();
            validated.then((res) => {
                console.log('--res',res);
                createKP(this.params()).then((res)=>{
                    console.log('--创建开票',res);
                    if (res.code !== 200) {
                        this.$notify(res.message);
                    }else{
                        this.$notify({
                            type: 'success',
                            message: '提交成功'
                        });
                        setTimeout(()=>{
                            this.goBack();
                            //this.$router.push("/guaranteeInfo");
                        },2000)
                    }
                });
                // this.addSqrInfo().then(() => {
                //     this.$router.push("/guaranteeInfo");
                // });
            }).catch((err) => {
                console.log('请完整填写表单数据',err);
            });
        },
        //初始化数据
        initData(){
            let sourceList=[];
            let ddListAll={};
            this.list.map(i => {
                i.dataList.map(j => {
                    j.source && sourceList.push(j.source);
                });
            });
            sourceList.map(i=>{
                switch(i){
                    case 'codeList_zzlx':
                        ddListAll[i]=this[this.nTtlxCode[this.formData.nTtlx]];
                        break;
                    case 'codeList_ry':
                        ddListAll[i]=this.ryxx.filter(item=>String(item.nRylx)===this.formData.nTtlx)
                            .map(item=>Object({value:item.cTtmc,text:item.cTtmc}));
                        break;
                    default:
                        ddListAll[i]=this[i];
                        break;
                }
            });
            this.ddListAll=ddListAll;
            console.log('--sourceList',ddListAll);
        },
        //获取数据
        getData(){
            const kpInfo=JSON.parse(sessionStorage.getItem('kpInfo')||'{}');
            const {dbid,cBdh,cBxgs}=kpInfo;
            this.dbid=dbid;
            this.formData.cDbh=cBdh;
            this.cBxgs=cBxgs;
            console.log('--kpInfo',kpInfo,dbid,cBdh,cBxgs);

            // 获取人员信息
            getkpRyxx({dbid}).then((res) => {this.ryxx=res.data;});
            //发票类型
            getCode({codetype: 902001}).then((res) => {this['codeList_902001'] = transformDdl(res.data);});
            //抬头类型
            getCode({codetype: 902003}).then((res) => {this['codeList_902003'] = transformDdl(res.data);});
            // 证件(照)类型-证件 个人
            getCode({codetype: 105000}).then((res) => {this['codeList_105000'] = transformDdl(res.data);});
            // 证件(照)类型-证照 企业
            getCode({codetype: 109000}).then((res) => {this['codeList_109000'] = transformDdl(res.data);});
        }

    },
    created() {
       console.log('--created 111',this.formData);
        this.getData();
    }
}
</script>

<style lang="less" scoped>

 #kaipiao{
    width: 100%;
    height: 100%;
    overflow: hidden;

         .fd-textarea{
             height: auto;
         }
}

</style>
